import React, { type JSX } from 'react'
import { useTranslation } from 'react-i18next'

import { useSessionEntity } from '@context/EntityContext'

import { Body1, Heading3, Heading6, Title1 } from '@ui/Typography'

import { isTickmillUKType } from '@utils/companyName.utils'

import { APKQr } from '@assets/QRCodes/APK.qr'
import { AppleQr } from '@assets/QRCodes/Apple.qr'
import { GooglePlayQr } from '@assets/QRCodes/GooglePlay.qr'

import styles from './AppMarketQRCode.module.scss'

export const AppMarketQRCode = (): JSX.Element => {
  const { t } = useTranslation()

  const entity = useSessionEntity()

  return (
    <div className={styles.appMarket}>
      <Heading3>{t('Download the Tickmill Mobile App')}</Heading3>
      <div className={styles.codeWrapper}>
        <div>
          <Heading6 className={styles.title} medium>
            {t('iOS')}
          </Heading6>
          <div className={styles.code}>
            <AppleQr />
          </div>
        </div>
        <div>
          <Heading6 className={styles.title} medium>
            {t('Android')}
          </Heading6>
          <div className={styles.code}>
            <GooglePlayQr />
          </div>
        </div>
        <div>
          <Heading6 className={styles.title} medium>
            {t('AndroidApk')}
          </Heading6>
          <div className={styles.code}>
            <APKQr />
          </div>
        </div>
      </div>
      <div>
        <Title1 isParagraph>
          {t(
            'Download the Tickmill Mobile app to get the best trading experience right in your pocket'
          )}
        </Title1>
      </div>
      {isTickmillUKType(entity) && (
        <div className='mt-5'>
          <Body1 medium>* {t('Only available for services related to CFD')}</Body1>
        </div>
      )}
    </div>
  )
}
